import React from 'react';
import PropTypes from 'prop-types';

/**
 * Youtube component
 * @param {Object} props Component properties
 */
export function Youtube({ videoId = '', autoplay = false, muted = false, showRelated = 1, className = '' }) {
  const url = `//www.youtube.com/embed/${videoId}?autoplay=${autoplay}&mute=${muted}&rel=${showRelated}`;

  return <iframe className={className} src={url} title="Video Player" allowFullScreen />;
}

Youtube.propTypes = {
  autoplay: PropTypes.bool.isRequired,
  videoId: PropTypes.string.isRequired,
  muted: PropTypes.bool,
  showRelated: PropTypes.number,
  className: PropTypes.string,
};
